module.exports = __webpack_public_path__ + "img/BG000694329.a7cb4b04.png";